export const BACKEND_URL = process.env.REACT_APP_BACKEND_BASE_URL || "http://149.102.147.200/api/v1/";
export const SOCKET_ENDPOINT = "http://149.102.147.200/";
export const ROLE = {
  SUPER_ADMIN: "SUPER_ADMIN",
  RESTAURANT_USER: "RESTAURANT_USER",
  RESTAURANT_ADMIN: "RESTAURANT_ADMIN",
};

export const trainingLevel = {
  level1: "Level 1",
  level2: "Level 2",
  level3: "Level 3",
};

export const quillModules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ["bold", "italic", "underline", "strike"],
    [{ color: [] }, { background: [] }],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ align: [] }],
  ],
};

export const complianceType = [
  {
    title: "INTRODUCTION",
    value: "INTRODUCTION",
    image_path: "./compliance_1.jpg",
  },
  {
    title: "CROSS CONTAMINATION",
    value: "CROSS_CONTAMINATION",
    image_path: "./compliance_2.jpg",
  },
  {
    title: "CLEANING",
    value: "CLEANING",
    image_path: "./compliance_3.jpg",
  },
  {
    title: "CHILLING",
    value: "CHILLING",
    image_path: "./compliance_4.jpg",
  },
  {
    title: "COOKING",
    value: "COOKING",
    image_path: "./compliance_5.jpg",
  },
];

export const quillFormats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "color",
  "background",
  "list",
  "bullet",
  "align",
];
